module.exports = "https://static.energy5.com/_next/static/images/retailBg-b0e381c51071b8cb3216f1d1e87d01bb.webp";